import type {
  AdminDto,
  AgentDto,
  CancelFunction,
  ChangeFunction,
  ServiceUserDto,
  SuperUserDto,
  SystemUserDto,
  TemplateDto,
  UserDto,
} from './api/models/types'
import { UserRole } from './api/models/definitions'
import type { Recipient } from './modules/recipient/models/recipient.model'

export const KILOGRAM = 'kg'
export const METER = 'm'
export const VOLUME = 'm³'
export const STATUS = 'Status'
export const MOTION_POLL_MIN = 3
export const MOTION_POLL_MAX = 60
export const REFRESH_MOTION = 'refresh-motion'
export const UPDATE_MOTION = 'update-motion'
export const SCROLL_MOTION = 'scroll-motion'
export const REFRESH_HOME = 'refresh-home'
export const UPDATE_HOME = 'update-home'
export const REFRESH_ACTION = 'refresh-action'
export const DASHBOARD_UPDATE_DURATION = 300000

export const enum SIunit {
  Weight = 0,
  Volume = 1,
}

export const DEFAULT_SERVICE_REQUEST_RECIPIENT_FORM: Recipient = {
  firstName: undefined,
  lastName: undefined,
  address1: undefined,
  address2: undefined,
  phone: undefined,
  email: undefined,
  doorAccessCode: undefined,
  zipCode: undefined,
  city: undefined,
}

export const DEFAULT_SERVICE_REQUEST_CHANGE: ChangeFunction = {
  extendAccessPointDays: false,
  changeName: false,
  changeAddress: false,
  changePhone: false,
  changeEmail: false,
  changeDoorAccessCode: false,
  changeLockerLocation: false,
  leaveOutsideDoor: false,
  knockOnDoor: false,
  noIdRequirement: false,
  messageToDriver: false,
  newDeliveryAttempt: false,
}

export const DEFAULT_SERVICE_REQUEST_CANCEL: CancelFunction = {
  cancelShipment: false,
}

export const DEFAULT_USER_ADD_FORM: AdminDto | AgentDto | SuperUserDto | UserDto = {
  userId: 0,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  phone: undefined,
  organization: undefined,
  description: undefined,
  isActive: true,
  isActivated: false,
}

export const DEFAULT_USER_EDIT_FORM: AdminDto | AgentDto | SuperUserDto | UserDto = {
  userId: 0,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  phone: undefined,
  organization: undefined,
  description: undefined,
  userRole: null,
  isActive: false,
  isActivated: false,
  identityProvider: undefined,
  activationCode: undefined,
  validUntilDate: undefined,
  createdByUserFullname: undefined,
  updateByUserFullname: undefined,
  createdDate: undefined,
  updateDate: undefined,
  activationDate: undefined,
  lastUserActivityDate: undefined,
}

export const DEFAULT_SERVICE_USER_ADD_FORM: ServiceUserDto = {
  userId: 0,
  firstName: undefined,
  lastName: undefined,
  organization: undefined,
  description: undefined,
  userApiKey: undefined,
  isActive: true,
  userType: 35,
}

export const DEFAULT_SYSTEM_USER_ADD_FORM: SystemUserDto = {
  userId: 0,
  firstName: undefined,
  lastName: undefined,
  microservice: undefined,
  description: undefined,
}

export const DEFAULT_TEMPLATE_ADD_FORM: TemplateDto = {
  userId: 0,
  firstName: undefined,
  organization: undefined,
  description: undefined,
  isActive: true,
  userRole: UserRole.User,
}

export const DEFAULT_EDIT_SERVICE_USER: ServiceUserDto = {
  userId: 0,
  firstName: undefined,
  lastName: undefined,
  organization: undefined,
  description: undefined,
  isActive: false,
  userApiKey: undefined,
  createdByUserFullname: undefined,
  updateByUserFullname: undefined,
  createdDate: undefined,
  updateDate: undefined,
}

export const DEFAULT_SYSTEM_USER_EDIT_FORM: SystemUserDto = {
  userId: 0,
  firstName: undefined,
  lastName: undefined,
  microservice: undefined,
  description: undefined,
  createdByUserFullname: undefined,
  updateByUserFullname: undefined,
  createdDate: undefined,
  updateDate: undefined,
}

export const DEFAULT_TEMPLATE_EDIT_FORM: TemplateDto = {
  userId: 0,
  firstName: undefined,
  organization: undefined,
  description: undefined,
  isActive: false,
  userRole: UserRole.User,
  createdByUserFullname: undefined,
  updateByUserFullname: undefined,
  createdDate: undefined,
  updateDate: undefined,
}
